export default __webpack_public_path__ + "files/df29fd5007ba01096d6b7d70342a78ff.woff2";